import { IS_AGENT_APP, isAldeia } from "hooks/useAldeia"
import React from "react"
import { twMerge } from "tailwind-merge"

export interface CardProps {
  children: React.ReactNode
  className?: string
  headerClassName?: string
  contentClassName?: string
  title?: string | React.ReactNode
  extra?: React.ReactNode
  style?: React.CSSProperties
}

function Card(props: CardProps) {
  const showHeader = props.title || props.extra
  return (
    <div className={twMerge("bg-base-100 kinbox:shadow rounded-app kinbox:px-2", props.className)} style={props.style}>
      {showHeader && (
        <header
          className={twMerge(
            "p-4 pb-3 flex items-center w-full justify-between ",
            props.headerClassName,
            IS_AGENT_APP ? "" : "max-h-14  h-full",
          )}
        >
          <h2 className="text-xl font-bold">{props.title}</h2>
          {props.extra}
        </header>
      )}
      <section className={props.contentClassName}>{props.children}</section>
    </div>
  )
}

export default Card
